import React from "react"
import Img from "gatsby-image";
import {
    Box, 
} from "@chakra-ui/core"
import { StaticQuery, graphql } from "gatsby";


export const Logo = () => (
    <StaticQuery
      query={graphql`
      {
        logo: file(relativePath: {eq: "icon.png"}) {
          id
          childImageSharp {
            fluid(maxWidth: 500) {
              ...GatsbyImageSharpFluid
            }
          }
        }
      }
      `}
      render={data => (
        <Box >
          <Img fluid={data.logo.childImageSharp.fluid} alt="Prolific Coast Seeds" />
        </Box>
  
      )}
    />
  )
  